import type { VendedorDTO } from '../../../model/kartera-api-model'

export {
    AVATAR_TONES,
    errorMessage,
    formatCount,
    formatSpokenDate,
    initials,
    labelize,
    pageWindow,
    personName,
    phoneHref,
    statusKey,
} from '../../customers/common/customer-common'

export const SELLERS_PATH = '/vendedores'

export const editSellerLocation = (id: number, backUrl = SELLERS_PATH) => ({
    pathname: `${SELLERS_PATH}/${id}/edit`,
    state: { backUrl },
})

export const sellerContact = (vendedor?: Pick<VendedorDTO, 'correo' | 'telefono' | 'rfc'> | null) => ({
    email: String(vendedor?.correo || '').trim(),
    phone: String(vendedor?.telefono || '').trim(),
    rfc: String(vendedor?.rfc || '').trim(),
})
